import { AppThunk } from '../store';

export const setMessage =
  (message: string): AppThunk =>
  dispatch => {
    dispatch({
      type: 'MESSAGE',
      payload: { message },
    });
  };

export const setOpen =
  (open: boolean): AppThunk =>
  dispatch => {
    dispatch({
      type: 'OPEN',
      payload: { open },
    });
  };

export const setSeverity =
  (severity: string): AppThunk =>
  dispatch => {
    dispatch({
      type: 'SERVEITY',
      payload: { severity },
    });
  };
export const setDuration =
  (duration: number | null): AppThunk =>
  dispatch => {
    dispatch({
      type: 'DURATION',
      payload: { duration },
    });
  };
